import { ev } from '@/consts'
import { useUserInfo, useSystemInfo } from '@/store'
import { generateFingerprint } from '@/utils'
import * as api from '@/api'
import { isInAndroidApp, isInIframe, isInPWA } from '@/env'

interface MTInitInfo {
  website_push_id: string;
  code: number;
  master_secret: string;
  passwd: string;
  pull: number;
  regid: string;
  sess: string;
  tagalias: number;
  uid: number;
  vapid_pubkey: string;
}

type dataType = {
  code: number,
  content: string,
  message: string,
};

interface InitType {
  appkey: string; //开发者在 URORA 平台注册的应用appkey，必填
  user_str: string; //用户唯一标识，必填
  swUrl?: string; //默认 "/sw.min." + sdkEnv.version + ".js"
  debugMode?: boolean; //默认 false,
  webSocketUrl?: string; //如果不存在则用 baseUrl
  fail?: (data: dataType | undefined) => void; //初始化失败回调
  success?: (data: dataType | undefined) => void; //初始化成功回调
  webPushcallback?: (code: number, tip: string) => void;
  canGetInfo?: (d: MTInitInfo) => void;
  custom?: (Callback: () => void) => void; //自定义提示可用时回调，完成操用后调用Callback可申请
}

let appkey = ''
let gguid = ''
let fp = ''

// const notificationPermission = window.Notification?.permission
ev.on('login', () => {
  // if (notificationPermission !== 'default') {

  // console.log('%c [ notificationPermission init login ]-48', 'font-size:13px; background:#9e23d2; color:#e267ff;', notificationPermission)
  init()
  // }
})

// ev.on('restore', (d: any) => {
//   console.log('restore',  'init webpush')
//   if (d[0].userInfo && d[1].$id === 'userInfo') init()
// })

ev.on('logout', () => {
  gguid = ''
  // if (notificationPermission !== 'default') {
  // console.log('%c [ notificationPermission logout ]-62', 'font-size:13px; background:#fc9c21; color:#ffe065;', notificationPermission)

  init()
  // }
  // window.MTpushInterface?.unSubscribe()
})

let _loaded = false
const loadScript = () => {
  if (_loaded) return Promise.resolve()

  return new Promise((resolve, reject) => {
    var s = document.createElement('script');
    s.src = '/static/libs/webSdk.produce.min.3.0.0.js';
    s.async = true;
    document.head.appendChild(s);

    s.onload = () => {
      _loaded = true
    }

    s.onerror = () => {
      const s = 'failed to load webpush script'
      console.error(s)
      reject(s)
    }

    window.MTpushInterfaceReady = () => {
      const MTpushInterface = window.MTpushInterface

      // 极光通道断开连接时的回调
      MTpushInterface.mtPush.onDisconnect(() => {
        console.log('onDisconnect')
        initMTpushInterface()
      })

      // 得到推送消息(web推送，浏览器厂商通道)
      MTpushInterface.onMsgReceive((msgData) => {
        // msgData数据结构{data:{xxx},type:0} type:0是极光通道，1是系统通道
        console.log('得到推送消息:', msgData)
      })

      resolve(true)
    }
  })
}

let inited = false
function initMTpushInterface() {
  if (inited) return Promise.resolve()
  if (!appkey) {
    return Promise.reject('appkey is not set')
  }

  return new Promise((resolve, reject) => {
    const MTpushInterface = window.MTpushInterface

    // 推送初始化
    MTpushInterface.init({
      appkey,
      user_str: fp,
      // webSocketUrl: baseUrl,
      // debugMode: true,
      fail(err) {
        console.log('在线推送创建失败', err)
        reject(err)
      },
      success(data) {
        console.log('在线推送创建成功', data)
        inited = true
        resolve(data)
      },
      webPushcallback(code, tip) {
        console.log('用户得到的状态码及提示', code, tip)
      },
      swUrl: '/sw.produce.min.3.0.9.js',
      canGetInfo(data) {
        //此时可以得到通知的一些配置数据，在此回调函数之后可以得到RegId
        console.log(data) //相关配置信息
        console.log('得到RegId', MTpushInterface.getRegistrationID())
      },
      custom: (fuc) => {
        //当使用自定义提示配置时，需手动调用fuc()来请求通知权限。只能通过custom得到请求通知权限函数。
        //fuc() 调用时会请求通知权限
        console.log("自定义推送请求权限方法", fuc)
      },
    } as InitType)
  })
}

function initMT() {
  Promise.all([
    getWebpushConfig(),
    loadScript(),
  ])
    .then(initMTpushInterface)
    .then(() => {
      console.log('gguid', gguid)
        if (gguid) {
          const { tenantCode } = useUserInfo().userInfo!
          window.MTpushInterface.setTagsAlias({ tags: [tenantCode], alias: gguid });
        } else {
          const { tenantCode } = useSystemInfo().merchantConfig || {}
          window.MTpushInterface.setTagsAlias({ tags: [tenantCode], alias: fp });
        }
    })
    .catch((err) => {
      console.error('failed to init webpush', err)
    })
}

function getWebpushConfig() {
  if (appkey) return Promise.resolve()

  return api.getWebpushConfig()
    .then(({code, data}) => {
      if (code === 1 && data) {
        appkey = data.appKey
        // baseUrl = data.baseUrl
      } else {
        throw new Error('failed to get webpush config')
      }
    })
}

async function init() {
  // const notificationPermission = window.Notification?.permission
  // console.log('%c [ notificationPermission init----- ]-185', 'font-size:13px; background:#dd16be; color:#ff5aff;', notificationPermission)

  if (isInAndroidApp || isInIframe || !isInPWA && location.pathname == '/template/') return

  // console.log('%c [ init ]-189', 'font-size:13px; background:#72e730; color:#b6ff74;',)
  fp = await generateFingerprint()
  if (useUserInfo().isLoggedin) {
    const _gguid = useUserInfo().userInfo!.guid.replace('-', '_')
    if (gguid === _gguid) return
    gguid = _gguid
  } else {
    gguid = ''
  }
  initMT()
}

export default init

// if (!(isInAndroidApp || isInIframe || !isInPWA && location.pathname == '/template/')) {

//   console.log('%c [ requestPermission ]-195', 'font-size:13px; background:#1c106d; color:#6054b1;',)
//   window.Notification?.requestPermission()
// }
